const $ = require('jquery');

// width at which the dekstop menu is show
const menuChange = 1000;
let stuck = false;

const $nav = $('header');
const $mainSection = $('main');
let headerHeight;

if ($('header').hasClass('sticky')) {
  document.addEventListener('scroll', stickMenuCheck, {
    passive: true,
  });
  document.addEventListener('scroll', stickMenuCheck);

  window.addEventListener('resize', stickMenuCheck, {
    passive: true,
  });
}

function stickMenuCheck() {
  // console.log('called');
  // reset the offset
  const offset = $('header .main-menu')[0].offsetTop;
  headerHeight = $('header').height();
  const scrolledOffset = $(document).scrollTop();
  if (window.innerWidth >= menuChange) {
    if (scrolledOffset > offset && !stuck) {
      // stick it
      stickMenu(offset);
    } else if (scrolledOffset < offset && stuck) {
      // unstick it
      unstickMenu();
    }
  } else if (stuck) {
    unstickMenu();
  }
}

function stickMenu(offset) {
  stuck = true;
  $nav.addClass('stuck');
  $nav.css('top', `-${offset + 1}px`);
  $mainSection.css('margin-top', headerHeight);
}

function unstickMenu() {
  $nav.removeClass('stuck');
  $nav.css('top', '');
  $mainSection.css('margin-top', '');
  stuck = false;
}
